import {
  OnInit,
  Component,
  ViewEncapsulation,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { RouteModalService } from 'src/app/shared/services/route-modal.service';

import {
  OrderStatusTypes,
  EOrderStatusFlow,
  ETableInProgressStatusFlow,
} from 'src/app/domain/enums/order-status-types.enum';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';

import { NotifierService } from 'angular-notifier';

import { ReplaySubject, Subject, firstValueFrom, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatSelect } from '@angular/material/select';
import { tabMappingsInbound, tabMappingsOutbound } from './utils/tabMapping';
import { CreateInboundOrderComponent } from './modals/create-inbound-order/create-inbound-order.component';
import { ResponseTableModel } from 'src/app/domain/models/response-table.model';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { BusinessPartnerDto } from 'src/app/domain/models/dto/business-partner.dto';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TableOrdersAdminComponent } from './table-orders-admin/table-orders-admin.component';
import { Moedas } from 'src/app/domain/constants/moeda.constant';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit, OnDestroy {
  tenant: string = '';
  rType: string = '';
  statusFlow: string = '';
  tableTitle: string = '';
  loading: boolean = false;
  pageSize: number = 10;
  pageNumber: number = 0;
  totalElements: number;

  modal;
  tableDisplayedColumns: string[];
  private readonly notifier: NotifierService;
  public orders: ResponseTableModel<InboundOrderDto[]>;

  showOrderError: boolean = false;
  haveOrders: boolean;

  isMobile: boolean;
  showTables = false;
  hideTabs: boolean = false;
  statusQueryParam: string = '';

  filterForm: FormGroup;
  moedas = Moedas;
  startDate = new Date();
  currency: string = '';
  currentTab: string = 'Pendente análise';
  availableFilters: string[] = [];

  partners: BusinessPartnerDto[] = [];
  agencies: BusinessPartnerDto[] = [];
  agencyFilterCtrl = new FormControl('');
  filteredAgencies: ReplaySubject<BusinessPartnerDto[]> = new ReplaySubject(1);

  searchControl = new FormControl('');

  @ViewChild('agencySelect', { static: false }) agencySelect!: MatSelect;
  @ViewChild(TableOrdersAdminComponent)
  tableOrdersAdmin: TableOrdersAdminComponent;
  private _onDestroy = new Subject<void>();

  sendOptions = [
    { value: 'SWIFT', label: 'SWIFT' },
    { value: 'NIUM', label: 'NIUM' },
  ];

  flowOptions = [
    { value: 'D0', label: 'D0' },
    { value: 'D+1', label: 'D+1' },
    { value: 'D+2', label: 'D+2' },
    { value: 'Termo D0', label: 'Termo D0' },
    { value: 'Termo D1', label: 'Termo D1' },
    { value: 'Termo D2', label: 'Termo D2' },
  ];

  confirmationTreasuryOptions = [
    { value: null, label: 'Todos' },
    { value: false, label: 'Aguardando informações da tesouraria' },
    { value: true, label: 'Pronto para boletar' },
  ];

  pendencyTypeOptionsOutbound = [
    { value: 'all', label: 'Todas' },
    { value: 'pending_info', label: 'Pendente informações' },
    { value: 'awaiting_quotation', label: 'Aguardando cotação' },
  ];

  pendencyTypeOptionsInbound = [
    { value: 'all', label: 'Todas' },
    { value: 'payment_reproved', label: 'Pagamento reprovado' },
    { value: 'pending_payment_info', label: 'Pendente informações de pagamento' },
    { value: 'identified_abroad', label: 'Pendente informações' },
  ];

  get pendencyTypeOptions() {
    return this.rType == '0'
      ? this.pendencyTypeOptionsInbound
      : this.pendencyTypeOptionsOutbound;
  }

  demeBanks$: Observable<string[]>;

  get filterFormControls() {
    return this.filterForm.controls;
  }

  get filter(): any {
    const filter = this.filterForm.value;
    return filter;
  }

  constructor(
    private readonly modalService: BoobleModalService,
    private readonly routeModalService: RouteModalService,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly ordersService: OrdersService,
    private readonly companyService: CorporateAccountService,
    private readonly bankService: BankAccountService
  ) {
    this.notifier = notifierService;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  async ngOnInit() {
    this.initializeForm();

    this.pageSize = +sessionStorage.getItem('orders-admin-page-size') || 10;

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');
      const rType = params.get('rType');

      if (result) this.tenant = params.get('tenant');
      if (rType) this.rType = params.get('rType');

      if (this.rType == '0') {
        this.tableDisplayedColumns = [
          'id',
          'createdDate',
          'companyName',
          'cnpj',
          'amount',
          'orderSource',
          'tipoPessoa',
          'action',
        ];
      } else {
        this.tableDisplayedColumns = [
          'id',
          'clientInfo',
          'createdDate',
          'amount',
          'action',
        ];
      }
    });

    this.route.queryParamMap.subscribe((queryParams) => {
      this.statusQueryParam = queryParams.get('status') || '';
    });

    this.routeModalService.verifyRouteParamsModal();

    this.applyMappingBasedOnStatus();

    const partnersRes = await firstValueFrom(
      this.companyService
        .getPartnersList()
        .pipe(
          catchError(() =>
            of({ data: [] } as ResponseObjectModel<BusinessPartnerDto[]>)
          )
        )
    );

    this.partners = partnersRes.data ?? [];
    this.agencies = this.partners;
    this.filteredAgencies.next(this.agencies);

    this.agencyFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => this.filterAgencies());

    this.ordersService.listenerUpdate.subscribe(() => {
      this.initializeWithPagination(
        this.statusFlow,
        this.rType,
        this.pageNumber,
        this.pageSize
      );
    });

    this.isMobile = window.innerWidth <= 820 ? true : false;
  }

  initializeForm() {
    this.filterForm = this.fb.group({
      statusFlow: [null],
      currency: [null],
      name: [''],
      personType: [''],
      document: [''],
      createdDate: [null],
      slipCode: [''],
      id: [''],
      agency: [''],
      sendOption: [null],
      value: [''],
      settlementFlow: [null],
      bankCurrencyTreasury: [''],
      levelingRateTreasury: [''],
      pendencyType: ['all'],
      confirmationTreasury: [null],
      spread: [''],
    });

    this.filterFormControls.currency.valueChanges.subscribe((currency) => {
      if (currency && currency.value) {
        this.currency = `${currency.value} `;

        this.demeBanks$ = this.bankService
          .getDemeBanks(currency.value)
          .pipe(
            map((v) =>
              v.data
                .filter((x) => x.remmitanceTypes.includes('OUTBOUND'))
                .map((x) => x.bankName)
            )
          );
      }
    });

    this.filterFormControls.personType.valueChanges.subscribe(() => {
      this.filterFormControls.document.setValue('', { emitEvent: false });
    });
  }

  onFilter() {
    this.pageNumber = 0;
    this.initializeWithPagination(
      this.statusFlow,
      this.rType,
      this.pageNumber,
      this.pageSize
    );
  }

  onClearFilters() {
    this.filterForm.reset({
      statusFlow: null,
      currency: null,
      id: '',
      name: '',
      personType: '',
      document: '',
      createdDate: null,
      slipCode: '',
      agency: '',
      sendOption: null,
      value: '',
      settlementFlow: null,
      bankCurrencyTreasury: '',
      levelingRateTreasury: '',
      pendencyType: 'all',
      confirmationTreasury: null,
      spread: '',
    });

    this.searchControl.reset('');

    this.currency = '';
    this.demeBanks$ = null;
    this.pageNumber = 0;

    if (this.statusQueryParam === 'pendencia' && this.rType == '1') {
      this.statusFlow = `flow=${EOrderStatusFlow.PAYMENT_REPROVED}&flow=${EOrderStatusFlow.PENDING_INVOICE_ATTACHMENT}&flow=${EOrderStatusFlow.PENDING_ORDER_INFORMATION}&flow=${EOrderStatusFlow.AVAILABLE_QUOTATION}`;
    }

    this.initializeWithPagination(
      this.statusFlow,
      this.rType,
      this.pageNumber,
      this.pageSize
    );
  }

  initializeWithPagination(
    status: string,
    rType: string,
    page: number,
    pageSize: number
  ) {
    const filters = { ...this.filterForm.value };

    if (!filters.personType) {
      delete filters.personType;
    }

    if (filters.currency) {
      filters.currency = filters.currency.value;
    }

    if (filters.createdDate) {
      filters.createdDate = filters.createdDate.toISOString().split('T')[0];
    }

    if (filters.id) {
      filters.id = filters.id.trim();
    }

    const searchValue = this.searchControl.value?.trim() || '';

    this.loading = true;
    this.showTables = false;
    this.haveOrders = false;

    this.orders = null;
    this.ordersService
      .getAdminByStatusFlowTabsWithPagination(
        status,
        rType,
        page + 1,
        pageSize,
        filters,
        searchValue
      )
      .subscribe({
        next: (result) => {
          this.loading = false;
          if (result.data.content.length > 0) {
            if (
              result.data.totalElements !== undefined &&
              result.data.totalElements !== null
            ) {
              this.totalElements = result.data.totalElements;
            }
            this.orders = result.data;
            this.haveOrders = true;
            this.showTables = true;
          } else {
            this.loading = false;
            this.haveOrders = false;
            this.showTables = false;
          }
        },
        error: () => {
          this.loading = false;
          this.showOrderError = true;
          this.haveOrders = false;
          this.showTables = false;
        },
      });
  }

  updatePageData({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }) {
    this.initializeWithPagination(
      this.statusFlow,
      this.rType,
      pageNumber,
      pageSize
    );

    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
  }

  changeTabStatus(event: MatTabChangeEvent) {
    const tabLabel = event.tab.textLabel;
    const mapping =
      this.rType == '0'
        ? tabMappingsInbound[tabLabel]
        : tabMappingsOutbound[tabLabel];

    if (mapping) {
      this.currentTab = tabLabel;
      this.tableTitle = mapping.tableTitle;
      this.statusFlow = mapping.statusFlowRequest;
      this.tableDisplayedColumns = mapping.displayedColumns;
      this.availableFilters = mapping.filters || [];

      this.filterForm.reset({
        statusFlow: null,
        currency: null,
        id: '',
        name: '',
        personType: '',
        document: '',
        createdDate: null,
        slipCode: '',
        agency: '',
        sendOption: null,
        value: '',
        settlementFlow: null,
        bankCurrencyTreasury: '',
        levelingRateTreasury: '',
        pendencyType: 'all',
        confirmationTreasury: null,
        spread: '',
      });
      this.searchControl.reset('');
      this.currency = '';
      this.demeBanks$ = null;
      this.pageNumber = 0;

      this.initializeWithPagination(
        this.statusFlow,
        this.rType,
        this.pageNumber,
        this.pageSize
      );
    }
  }

  isFilterVisible(filterName: string): boolean {
    if (this.availableFilters.length === 0) {
      return true;
    }
    return this.availableFilters.includes(filterName);
  }

  applyMappingBasedOnStatus() {
    if (this.statusQueryParam === 'pendencia') {
      const tabLabel = 'Ordens com pendência';
      const mapping =
        this.rType == '0'
          ? tabMappingsInbound[tabLabel]
          : tabMappingsOutbound[tabLabel];

      if (mapping) {
        this.currentTab = tabLabel;
        this.tableTitle = mapping.tableTitle;
        this.statusFlow = mapping.statusFlowRequest;
        this.tableDisplayedColumns = mapping.displayedColumns;
        this.availableFilters = mapping.filters || [];
      }

      this.hideTabs = true;
    } else {
      this.statusFlow =
        this.rType == '0'
          ? `flow=${EOrderStatusFlow.IDENTIFYING_PAYMENT_ABROAD}`
          : `flow=${EOrderStatusFlow.PROCESSING}`;
      this.tableTitle =
        this.rType == '0'
          ? 'Ordens aguardando pagamento no exterior'
          : 'Ordens pendentes análise';

      const defaultMapping =
        this.rType == '0'
          ? tabMappingsInbound['Aguardando pagamento']
          : tabMappingsOutbound['Pendente análise'];

      if (defaultMapping) {
        this.availableFilters = defaultMapping.filters || [];
      }

      this.hideTabs = false;
    }

    this.filterForm.patchValue({
      personType: '',
    });
  }

  private filterAgencies() {
    const term = (this.agencyFilterCtrl.value || '').toString().toLowerCase();
    if (!term) {
      this.filteredAgencies.next(this.agencies);
      return;
    }
    this.filteredAgencies.next(
      this.agencies.filter((a) => {
        const name = (a.companyName || '').toLowerCase();
        const agency = String(a.agencyNumber ?? '');
        return name.includes(term) || agency.includes(term);
      })
    );
  }

  onPendencyTypeChange(event: { value: string }) {
    const pendencyType = event.value;

    if (this.rType == '0') {
      if (pendencyType === 'payment_reproved') {
        this.statusFlow = `flow=${EOrderStatusFlow.PAYMENT_REPROVED}`;
      } else if (pendencyType === 'pending_payment_info') {
        this.statusFlow = `flow=${EOrderStatusFlow.PENDING_PAYMENT_INFORMATION}`;
      } else if (pendencyType === 'identified_abroad') {
        this.statusFlow = `flow=${EOrderStatusFlow.IDENTIFIED_PAYMENT_ABROAD}`;
      } else {
        this.statusFlow = `flow=${EOrderStatusFlow.PAYMENT_REPROVED}&flow=${EOrderStatusFlow.PENDING_PAYMENT_INFORMATION}&flow=${EOrderStatusFlow.IDENTIFIED_PAYMENT_ABROAD}`;
      }
    } else {
      if (pendencyType === 'pending_info') {
        this.statusFlow = `flow=${EOrderStatusFlow.PAYMENT_REPROVED}&flow=${EOrderStatusFlow.PENDING_INVOICE_ATTACHMENT}&flow=${EOrderStatusFlow.PENDING_ORDER_INFORMATION}`;
      } else if (pendencyType === 'awaiting_quotation') {
        this.statusFlow = `flow=${EOrderStatusFlow.AVAILABLE_QUOTATION}`;
      } else {
        this.statusFlow = `flow=${EOrderStatusFlow.PAYMENT_REPROVED}&flow=${EOrderStatusFlow.PENDING_INVOICE_ATTACHMENT}&flow=${EOrderStatusFlow.PENDING_ORDER_INFORMATION}&flow=${EOrderStatusFlow.AVAILABLE_QUOTATION}`;
      }
    }

    this.pageNumber = 0;
    this.initializeWithPagination(
      this.statusFlow,
      this.rType,
      this.pageNumber,
      this.pageSize
    );
  }

  reloadPage() {
    window.location.reload();
  }

  goToOrdersHistory() {
    this.router.navigate([`${this.tenant}/admin/orders-history`, this.rType]);
  }

  openCreateInboundOrderModal() {
    this.modalService.present(CreateInboundOrderComponent);
  }

  openMassPaymentConfirm() {
    if (this.tableOrdersAdmin) {
      this.tableOrdersAdmin.openMassPaymentConfirm();
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
